export function formatCallDurationLabel(
    durationMs: number | null,
): string | null {
    if (!durationMs || durationMs <= 0) {
        return null;
    }

    const totalSeconds = Math.floor(durationMs / 1000);
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;

    if (minutes === 0) {
        return `${seconds}s`;
    }

    return `${minutes}m${seconds}s`;
}

export function formatCallBadgeLabel(value: string): string {
    return value
        .split('_')
        .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
        .join(' ');
}

export function isVoiceCallListeningOnly(
    call: {
        readonly routing_reason?: string | null;
    },
    silentListeningLabelSettingsEnabled: boolean = false,
): boolean {
    return (
        silentListeningLabelSettingsEnabled &&
        call.routing_reason === 'call_handling_answers_no_one'
    );
}

export function formatRoutingReasonLabel(
    reason: string,
    scheduleName?: string | null,
): string {
    if (reason === 'receptionist_schedule' && scheduleName) {
        return `Receptionist schedule: ${scheduleName}`;
    }
    if (reason === 'after_hours_receptionist') {
        return 'After hours receptionist';
    }
    return formatCallBadgeLabel(reason);
}
